module.exports = __webpack_public_path__ + "67d5c7f30dfac4f44174e1b3cdf695eb.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/chloe/victory.png
// module id = 130
// module chunks = 0